export default "/images/breastfeeding_environment_sm.jpg?f81697b4a8407f19a298de6a8129c67f";